import { render } from "./ErrorMessage.vue?vue&type=template&id=3fbf5e3c&scoped=true&ts=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts"

import "./ErrorMessage.vue?vue&type=style&index=0&id=3fbf5e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbf5e3c"]])

export default __exports__